import { EventEmitter } from '@angular/core';
import * as i0 from "@angular/core";
export class EventMantenedorEnfoqueService {
    constructor() {
        this.invokeFirstComponentFunction = new EventEmitter();
    }
    refreshTable() {
        this.invokeFirstComponentFunction.emit();
    }
}
EventMantenedorEnfoqueService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EventMantenedorEnfoqueService_Factory() { return new EventMantenedorEnfoqueService(); }, token: EventMantenedorEnfoqueService, providedIn: "root" });
